import Header from '../components/Header';
import Footer from '../components/Footer';
import { Gavel, CheckCircle2, TrendingUp, AlertCircle, HelpCircle } from 'lucide-react';

export default function TermsConditions() {
  const terms = [
    {
      title: '1. Acceptance of Terms',
      content: 'By accessing or using Finova (Pvt) Ltd, you agree to comply with and be bound by these terms. If you do not agree, you should not use our services.',
      icon: Gavel
    },
    {
      title: '2. User Eligibility',
      content: 'You must be at least 18 years old and possess a valid legal identity to apply for a loan. You represent that the information you provide is accurate and complete.',
      icon: CheckCircle2
    },
    {
      title: '3. Financial Obligations',
      content: 'Loan repayment schedules must be strictly followed. Failure to repay as agreed may result in penalty fees, a reduction in your Trust Score, and legal recovery actions.',
      icon: TrendingUp
    },
    {
      title: '4. Service Modification',
      content: 'We reserve the right to modify or discontinue any part of our service at any time. Changes to terms will be notified to you through your dashboard.',
      icon: AlertCircle
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Header */}
      <section className="pt-16 pb-16 bg-stripe-bg">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center space-y-6">
           <h1 className="text-4xl md:text-6xl font-black text-stripe-dark tracking-tighter italic">Terms & Conditions</h1>
           <p className="text-lg text-stripe-slate font-medium italic">Your agreement to use our platform</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 max-w-4xl mx-auto px-4 sm:px-6">
         <div className="space-y-16 px-4">
            {terms.map((t, i) => (
              <div key={i} className="flex flex-col md:row items-start gap-8">
                 <div className="w-12 h-12 bg-primary-50 rounded-2xl flex items-center justify-center text-primary-500 shrink-0 border border-primary-100 shadow-sm">
                    <t.icon size={24} />
                 </div>
                 <div className="space-y-4">
                    <h2 className="text-2xl font-black text-stripe-dark tracking-tight leading-none italic">{t.title}</h2>
                    <p className="text-stripe-slate text-lg leading-relaxed font-medium">{t.content}</p>
                 </div>
              </div>
            ))}

            <div className="p-10 bg-primary-50 rounded-[40px] border border-primary-100 shadow-lg mt-24">
               <div className="flex items-center gap-4 mb-6">
                  <HelpCircle size={28} className="text-primary-500" />
                  <h3 className="text-2xl font-black text-primary-900 tracking-tight leading-none italic">Need Clarification?</h3>
               </div>
               <p className="text-lg text-primary-800 leading-relaxed font-medium mb-8">
                 If you have any questions regarding our terms or financial protocols, please contact our support team. We're here to ensure total transparency.
               </p>
               <a href="/contact" className="btn-primary px-10 rounded-full font-black text-sm uppercase tracking-widest italic">Contact Support</a>
            </div>
         </div>
      </section>

      <Footer />
    </div>
  );
}
